<template>
  <div class="manual-container">
    <p class="component-title">{{ $t('PEER.SendScoreBoard.title') }}</p>
    <div class="scoreboard-grid">
      <ul>
        <li class="table-title">{{ $t('PEER.SendScoreBoard.emailList') }}</li>
        <li v-for="(mail, index) in email" :key="index">{{ mail }}</li>
      </ul>
      <div>
        <div class="table-title">
          {{
            $t('PEER.SendScoreBoard.subtitle1') +
            ` "` +
            paper.title +
            `" ` +
            $t('PEER.SendScoreBoard.subtitle2')
          }}
        </div>
        <ScoringPaperExample
          :paperQuestion="paper.questions"
          :numberOfQuestion="paper.numberOfEvaluations"
        />
      </div>
    </div>
    <div class="button-wrapper">
      <button @click="createExcelFile()">평가지 링크 저장</button>
      <button @click="() => doPost()" :disabled="isSaveActive">
        {{ $t('PEER.SendScoreBoard.save') }}
      </button>
      <button @click="() => AC_INIT_PAPER()">{{ $t('PEER.SendScoreBoard.initialize') }}</button>
    </div>
    <ScaleLoader
      class="loading-wrapper component-center flex-row flex-center"
      :loading="loading"
      color="#7f7f7f"
      width="5px"
      height="50px"
    />
  </div>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { TabulatorComponent } from 'vue-tabulator';
import { mapActions, mapGetters, mapState } from 'vuex';
import ScoringPaperExample from './ScoringPaperExample';
import { postPaperData, sendPaperToEmail } from '@/api/evaluationPaper';
import * as XLSX from 'xlsx';

export default {
  name: 'ScoringStandard',
  components: {
    TabulatorComponent,
    ScoringPaperExample,
    ScaleLoader,
  },
  data() {
    return {
      email: [],
      paper: null,
      createdPaperId: -1,
      isSaveActive: false,
      loading: false,
      isSend: false,
    };
  },
  computed: {
    ...mapGetters('peerPaper', ['GE_PAPER_DATA', 'GE_FORM_DATA']),
    ...mapState('peerPaper', ['downloadableData']),
    ...mapState('peerPaper', ['paperOriginData']),
  },
  methods: {
    ...mapActions('modal', ['AC_MODAL_OPEN']),
    ...mapActions('peerPaper', [
      'AC_MOVE_NEXT_EVALUTATION_STEP',
      'AC_INIT_PAPER',
      'AC_DOWNLOADABLE_DATA',
    ]),
    saveEvaluationLinksAsExcel() {
      const uploadedFileData = this.uploadedFileData || [];
      const downloadableData = this.downloadableData || [];

      this.createExcelFile(uploadedFileData, downloadableData);
    },
    doPost() {
      const data = this.GE_FORM_DATA;
      postPaperData(data).then((response) => {
        this.isSaveActive = true;
        this.createdPaperId = response.evaluationPaperId;

        const content =
          this.$i18n.locale === 'eng'
            ? 'The assessment paper has been saved.'
            : '평가지가 저장되었습니다.';
        const url = '';
        this.AC_MODAL_OPEN({
          content: content,
          url: url,
        });
      });
    },
    createExcelFile() {
      if (this.createdPaperId < 0) {
        const content =
          this.$i18n.locale === 'eng'
            ? 'You can send a message after you save the assessment.'
            : '평가지를 저장한 후에 메세지를 전송할 수 있습니다.';
        const url = '';
        this.AC_MODAL_OPEN({
          content: content,
          url: url,
        });
      } else {
        this.loading = true;

        sendPaperToEmail(this.createdPaperId).then((response) => {
          this.loading = false;
          this.isSend = true;

          const sortedResponse = response.outgoings.sort(function (a, b) {
            return a.email - b.email;
          });

          const firstSheetData = this.paperOriginData.data[0].data;
          const secondSheetData = [
            ['idx', 'link'],
            ...sortedResponse.map((currentValue) => {
              return [currentValue.email, currentValue.content];
            }),
          ];

          let workbook = XLSX.utils.book_new();
          const firstSheet = XLSX.utils.aoa_to_sheet(firstSheetData);
          const secondSheet = XLSX.utils.aoa_to_sheet(secondSheetData);

          XLSX.utils.book_append_sheet(workbook, firstSheet, 'Sheet 1');
          XLSX.utils.book_append_sheet(workbook, secondSheet, 'Sheet 2');

          XLSX.writeFile(workbook, 'UploadedData.xlsx');

          this.AC_DOWNLOADABLE_DATA({
            data: response.outgoings,
          });
        });
      }
    },
  },
  watch: {
    uploadedFileData(newVal) {
      console.log('uploadedFileData 변경됨:', newVal);
    },
  },
  created() {
    this.paper = this.GE_PAPER_DATA;
    this.paper.questions[0].answers.forEach((answer) => {
      this.email.push(answer.email);
    });
  },
};
</script>

<style lang="scss" scoped>
.scoreboard-grid {
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-gap: 10px;
  height: 80%;

  & > div,
  & > ul {
    padding: 10px;
    border: 2px solid black;
    border-radius: 10px;
    height: 100%;
    overflow: auto;
    box-shadow: 0 0 10px 0 #00000040;

    li {
      padding: 6px 0;
    }
  }

  .table-title {
    padding: 10px 0;
    border-radius: 5px;
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    color: gray;
    background: $SUB-COLOR;
  }
}

.loading-wrapper {
  width: 100%;
  height: 100%;
  background: #00000020;
}
</style>
